// src/pages/About.js
import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">About Page</h1>
        <p className="text-xl">This is the about section of our website.</p>
      </div>
    </div>
  );
};

export default About;
